import React from 'react';

import {labels, currentResource} from '../../../../../../../util/utils';

export const prop = 'gAType';
export const id = 'groupRoleColumn';

const getGroupRoleTypeLabel = (typeId) => {
	let grouplabel = currentResource.gaRoleType.find((x) => typeId === x.id)?.label;
	if (grouplabel) {
		return grouplabel;
	}

	return labels.notApplicable;
};

export const config = (labels) => ({
	id,
	label: labels.groupRole,
	propName: prop,
	width: 'minmax(var(--px-150), 1fr)',
	sortBy: prop,
	customCell: (item) => {
		return (
			<span title={getGroupRoleTypeLabel(item.gAType)} className="group-role ellipsis">
				{getGroupRoleTypeLabel(item.gAType)}
			</span>
		);
	}
});
